module.exports = new __parcel__URL__("shop_machines_bp_piece_of_home_cosmetic.6b702af6.png").toString();